define('models/composer/forms/QuestionGroup',[
    'lib/knockout',
    'lib/lodash4',
    'util/ObservableModel',
    'models/composer/forms/QuestionFactory',
    'models/composer/forms/VisibilityCondition'
], function (
    ko,
    _,
    ObservableModel,
    QuestionFactory,
    VisibilityCondition
) {
    'use strict';

    var QuestionGroupModel = ObservableModel.extend({
        defaults: {
            type: "questionGroup",
            name: '',
            optional: false,
            notes: '',
            weight: 0,
            manualWeight: false,
            defaultAnswersToHighest: false,
            defaultAnswersToNA: false,
            naEnabled: false,
            naSelected: false,
            questions: []
        },
        modelProperties: {
            questions: QuestionFactory,
            visibilityCondition: VisibilityCondition
        }
    }, function questionGroupModel_init() {
        var self = this;

        self.modelId = _.uniqueId("questionGroup");
        var hasFakeId = false;
        if (!self.id) {
            self.id = self.modelId;
            hasFakeId = true;
        }

        self.index = ko.observable(-1);

        self.addQuestion = function (data, index) {
            var newQuestion = new QuestionFactory(data);

            self.questions.splice(index, 0, newQuestion);
        };

        if (!self.visibilityCondition) {
            self.visibilityCondition = new ko.observable(null);
        }

        self.addVisibilityCondition = function() {
            self.visibilityCondition(new VisibilityCondition());
        };

        self.visibilityCondition.extend({
            validation: {
                validator: function (val) {
                    return !val || val.isValid();
                }
            }
        });

        self.name = self.name.extend({trimmed: null}); //trim whitespace off the name

        // Add Knockout-Validation functionality.
        self.name.extend({required: true});
        self.questions.extend({minLength: 1, deferred: true});
        self.weight.extend({
            number: true,
            required: true,
            max: 100,
            min: 0
        });
        ko.validation.group(self, {deep: true, live: true});

        self.questionMap = ko.computed(function () {
            return _.reduce(self.questions(), function (accumulator, question, index) {
                question.questionGroupIndex(self.index());
                question.index(index);
                accumulator[question.id] = question;
                return accumulator;
            }, {});
        });

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'questionGroup': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.unwrap = function (toIgnore, options) {
            toIgnore = toIgnore || {};
            options = options || {};
            var typeName = self.type();
            var ignore = [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "modelId",
                "unwrap",
                "addQuestion",
                "questions",
                "visibilityCondition",
                "addVisibilityCondition",
                "questionMap",
                "index"
            ];
            if (options.ignoreFakeIds && hasFakeId) {
                ignore.push('id');
            }
            var passToKids = false;
            if (toIgnore instanceof Array) { // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else { // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []);
                passToKids = true;
            }
            var data = ObservableModel.unwrap(self, ignore);
            data.questions = _.map(self.questions(), function (submodel) {
                return submodel.unwrap(passToKids ? toIgnore : undefined, options);
            });

            if(self.visibilityCondition && self.visibilityCondition()) {
                data.visibilityCondition = self.visibilityCondition().unwrap(passToKids ? toIgnore : undefined, options);
            }

            return data;
        };

    });

    return QuestionGroupModel;
});

